import { render, staticRenderFns } from "./SysCategoryModal.vue?vue&type=template&id=6a9cb940&"
import script from "./SysCategoryModal.vue?vue&type=script&lang=js&"
export * from "./SysCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports